import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-components',
  template: `
    <router-outlet></router-outlet>
  `,
})
export class GestaoUserTerceiroComponent implements OnInit {

  
  constructor( ) { }

  ngOnInit() {
  }
  

}
